import { useForm } from 'vee-validate'

export const useFormValidation = (
  validationSchema: Record<string, any>,
  initialValues: Record<string, any> = {}
) => {
  const { handleSubmit, errors, resetForm, setErrors } = useForm({
    validationSchema,
    initialValues
  })

  return { handleSubmit, errors, resetForm, setErrors }
}
